import { render } from "./VideoDetails.vue?vue&type=template&id=6735041f&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"

import "./VideoDetails.vue?vue&type=style&index=0&id=6735041f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6735041f"]])

export default __exports__